import { createRouter, createWebHistory } from 'vue-router';

import HomePage from '../views/HomePage.vue';
import VisitDashboard from '../views/VisitDashboard.vue';
import PageIndex from '../views/PageIndex.vue';
import LogicalMemoryAnna from '../views/LogicalMemory/LogicalMemoryAnna.vue';
import LogicalMemoryRobert from '../views/LogicalMemory/LogicalMemoryRobert.vue';
import LetterFInterview from '../views/VerbalFluency/LetterFInterview.vue';
import LetterFTranscription from '../views/VerbalFluency/LetterFTranscription.vue';
import SupermarketInterview from '../views/VerbalFluency/SupermarketInterview.vue';
import SupermarketTranscription from '../views/VerbalFluency/SupermarketTranscription.vue';
import WordListTrial1 from '../views/WordList/WordListTrial1.vue';
import WordListTrial2 from '../views/WordList/WordListTrial2.vue';
import WordListTrial3 from '../views/WordList/WordListTrial3.vue';
import WordListRecall from '../views/WordList/WordListRecall.vue';
import WordListRecognition from '../views/WordList/WordListRecognition.vue';
import ConstructionalPraxisInitial from '../views/ConstructionalPraxis/ConstructionalPraxisInitial.vue';
import ConstructionalPraxisRecall from '../views/ConstructionalPraxis/ConstructionalPraxisRecall.vue';
import ClockDrawing from '../views/ClockDrawing.vue';
import WAIS from '../views/WAIS.vue';
import TrailMakingA from '../views/TrailMaking/TrailMakingA.vue';
import TrailMakingB from '../views/TrailMaking/TrailMakingB.vue';
import BostonNaming from '../views/BostonNaming.vue';
import CASI from '../views/CASI.vue';
import VPASet1 from '../views/VerbalPairedAssociates/VPASet1';
import VPASet2 from '../views/VerbalPairedAssociates/VPASet2';
import VPASet3 from '../views/VerbalPairedAssociates/VPASet3';
import VPARecall from '../views/VerbalPairedAssociates/VPARecall';
import IntroductionScreen from '../views/IntroductionScreen.vue';
import EndScreen from '../views/EndScreen.vue';
import HearingTests from '../views/HearingTests.vue';
import UserLoginPage from '../views/UserLoginPage.vue';
import ScoringInternalLoginPage from '../views/ScoringInternalLoginPage.vue';
import ScoringInternalPage from '../views/ScoringInternal.vue';
import WireframesPage from '../views/WireframesPage.vue';
import WireframesHomePage from '../views/WireframesHomePage.vue';
import DashboardWireframe from '../views/DashboardWireframe.vue';
import ActDashboardMockup from '../views/ActDashboardMockup.vue';
import ActAssignmentsMockup from '../views/ActAssignmentsMockup.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: VisitDashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/home-legacy',
    name: 'HomeLegacy',
    component: HomePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: UserLoginPage,
    meta: { requiresAuth: false }
  },
  {
    path: '/page-index',
    name: 'Page Index',
    component: PageIndex,
    meta: { requiresAuth: true }
  },
  {
    path: '/logical-memory/anna',
    name: 'Logical Memory - Anna',
    component: LogicalMemoryAnna,
    meta: { requiresAuth: true }
  },
  {
    path: '/logical-memory/robert',
    name: 'Logical Memory - Robert',
    component: LogicalMemoryRobert,
    meta: { requiresAuth: true }
  },
  {
    path: '/verbal-fluency/letter-f/interview',
    name: 'Verbal Fluency - Letter F - Interview',
    component: LetterFInterview,
    meta: { requiresAuth: true }
  },
  {
    path: '/verbal-fluency/letter-f/transcription',
    name: 'Verbal Fluency - Letter F - Transcription',
    component: LetterFTranscription,
    meta: { requiresAuth: true }
  },
  {
    path: '/verbal-fluency/supermarket/interview',
    name: 'Verbal Fluency - Supermarket - Interview',
    component: SupermarketInterview,
    meta: { requiresAuth: true }
  },
  {
    path: '/verbal-fluency/supermarket/transcription',
    name: 'Verbal Fluency - Supermarket - Transcription',
    component: SupermarketTranscription,
    meta: { requiresAuth: true }
  },
  {
    path: '/word-list/trial1',
    name: 'Word List - Trial 1',
    component: WordListTrial1,
    meta: { requiresAuth: true }
  },
  {
    path: '/word-list/trial2',
    name: 'Word List - Trial 2',
    component: WordListTrial2,
    meta: { requiresAuth: true }
  },
  {
    path: '/word-list/trial3',
    name: 'Word List - Trial 3',
    component: WordListTrial3,
    meta: { requiresAuth: true }
  },
  {
    path: '/word-list/recall',
    name: 'Word List - Recall',
    component: WordListRecall,
    meta: { requiresAuth: true }
  },
  {
    path: '/word-list/recognition',
    name: 'Word List - Recognition',
    component: WordListRecognition,
    meta: { requiresAuth: true }
  },
  {
    path: '/constructional-praxis/intitial',
    name: 'Constructional Praxis - Initial',
    component: ConstructionalPraxisInitial,
    meta: { requiresAuth: true }
  },
  {
    path: '/constructional-praxis/recall',
    name: 'Constructional Praxis - Recall',
    component: ConstructionalPraxisRecall,
    meta: { requiresAuth: true }
  },
  {
    path: '/clock-drawing',
    name: 'Clock Drawing',
    component: ClockDrawing,
    meta: { requiresAuth: true }
  },
  {
    path: '/WAIS',
    name: 'WAIS',
    component: WAIS,
    meta: { requiresAuth: true }
  },
  {
    path: '/trail-making/a',
    name: 'Trail Making A',
    component: TrailMakingA,
    meta: { requiresAuth: true }
  },
  {
    path: '/trail-making/b',
    name: 'Trail Making B',
    component: TrailMakingB,
    meta: { requiresAuth: true }
  },
  {
    path: '/boston-naming',
    name: 'Boston Naming',
    component: BostonNaming,
    meta: { requiresAuth: true }
  },
  {
    path: '/CASI',
    name: 'CASI',
    component: CASI,
    meta: { requiresAuth: true }
  },
  {
    path: '/verbal-paired-associates/set1',
    name: 'Verbal Paired Associates - Set 1',
    component: VPASet1,
    meta: { requiresAuth: true }
  },
  {
    path: '/verbal-paired-associates/set2',
    name: 'Verbal Paired Associates - Set 2',
    component: VPASet2,
    meta: { requiresAuth: true }
  },
  {
    path: '/verbal-paired-associates/set3',
    name: 'Verbal Paired Associates - Set 3',
    component: VPASet3,
    meta: { requiresAuth: true }
  },
  {
    path: '/verbal-paired-associates/recall',
    name: 'Verbal Paired Associates - Recall',
    component: VPARecall,
    meta: { requiresAuth: true }
  },
  {
    path: '/introduction',
    name: 'IntroductionScreen',
    component: IntroductionScreen,
    meta: { requiresAuth: true }
  },
  {
    path: '/end',
    name: 'EndScreen',
    component: EndScreen,
    meta: { requiresAuth: true }
  },
  {
    path: '/hearing-tests',
    name: 'HearingTests',
    component: HearingTests,
    meta: { requiresAuth: true }
  },
  {
    path: '/scoring/login',
    name: 'ScoringLogin',
    component: ScoringInternalLoginPage,
    meta: { requiresScoringAuth: false }
  },
  {
    path: '/scoring/internal',
    name: 'ScoringInternal',
    component: ScoringInternalPage,
    meta: { requiresScoringAuth: true }
  },
  {
    path: '/wireframes',
    name: 'Wireframes',
    component: WireframesPage,
    meta: { requiresAuth: false }
  },
  {
    path: '/wireframes/home',
    name: 'WireframesHome',
    component: WireframesHomePage,
    meta: { requiresAuth: false }
  },
  {
    path: '/wireframes/dashboard',
    name: 'WireframesDashboard',
    component: DashboardWireframe,
    meta: { requiresAuth: false }
  },
  {
    path: '/wireframes/dashboard/mockup',
    name: 'ActDashboardMockup',
    component: ActDashboardMockup,
    meta: { requiresAuth: false }
  },
  {
    path: '/wireframes/dashboard/assignments-mockup',
    name: 'ActAssignmentsMockup',
    component: ActAssignmentsMockup,
    meta: { requiresAuth: false }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  // Routes with no auth requirement (wireframes) always pass through
  if (to.meta.requiresAuth === false && !to.meta.requiresScoringAuth) {
    next();
    return;
  }

  if (sessionStorage.getItem('refreshed') === 'true') {
    sessionStorage.removeItem('refreshed');
    if (to.path !== '/') {
      next('/');
    } else {
      next();
    }
  } else {
    const isLoggedIn = sessionStorage.getItem("isLoggedIn");
    const isScoringLoggedIn = sessionStorage.getItem("isScoringLoggedIn");

    if (to.meta.requiresScoringAuth) {
      if (!isScoringLoggedIn) {
        next("/scoring/login");
      } else {
        next();
      }
      return;
    }

    if (to.meta.requiresAuth) {
      if (!isLoggedIn) {
        next("/login");
      } else {
        next();
      }
      return;
    }

    if (to.path === '/login' && isLoggedIn) {
      next('/');
    } else if (to.path === '/scoring/login' && isScoringLoggedIn) {
      next('/scoring/internal');
    } else {
      next();
    }
  }
});

export default router;
